/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleSquareInSquare: {
  name: 'circle-square-in-square';
  data: string;
} = {
  name: 'circle-square-in-square',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2ZM8 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM9 8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H9Z" fill="currentColor"/></svg>`,
};
